var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16.002,
    viewBox: "0 0 20 16.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screenshot-at-May-06-18-01-08",
    transform: "translate(-111.999 335.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M128-335.893c-.084.024-.24.075-.348.118-.192.08-.2.085-.1.174.246.212,9.159,6.562,9.213,6.562.1,0,9.3-6.623,9.273-6.666a1.747,1.747,0,0,0-.366-.132c-.324-.1-.378-.1-8.925-.094C132.012-335.931,128.081-335.912,128-335.893Z",
    transform: "translate(-14.757)",
    fill: "#939a9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M112-291.494c0,6.335-.012,6.049.335,6.766a3.543,3.543,0,0,0,1.183,1.234c.736.4.212.377,8.485.377s7.75.024,8.485-.377a3.561,3.561,0,0,0,1.183-1.24c.353-.717.335-.438.324-6.748l-.018-5.781-4.384,4.134c-4.672,4.4-4.7,4.426-5.384,4.511a2,2,0,0,1-1.365-.383c-.23-.17-6.508-6.055-8.562-8.031L112-297.3Z",
    transform: "translate(0 -36.814)",
    fill: "#939a9f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email__icon.952e4d60695e10d82db21b11c91c032f.svg";
export { ForwardRef as ReactComponent };